import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { TextLine } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';

const CustomerContactCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, 'customer');
  if (!data) {
    return props?.value;
  }

  const { customerContactGroupName, customerContactName } = data;

  return (
    <Stack>
      <TextLine text={customerContactGroupName} />
      <TextLine text={customerContactName} isSubText />
    </Stack>
  );
};

export default CustomerContactCell;
